import { Alert, AlertProps, AlertTitle, AlertTitleProps } from '@mui/material';

export function MuiAlert(props: AlertProps) {
  return <Alert {...props} />;
}

export function MuiAlertTitle(props: AlertTitleProps) {
  return <AlertTitle {...props} />;
}
